import DetailNavTitle from '@/components/business/detail-nav-title';
import theme from '@/style';
import {debounce, goBack, goTo, inGameBox, openURL} from '@/utils';
import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {ScrollView, View} from 'react-native';
import {
  // BalanceListItem,
  PayMethod,
  getBalanceList,
  getPayMethod,
  goIncome,
  paySuccess,
} from './recharge.service';
import Spin from '@/components/basic/spin';
import {Success, upiPayment} from '@/utils';
import RechargeBalance from './recharge-balance';
import RechargeSelect, {WeekCardRechargeTabContext} from './recharge-select';
import RechargeChannel from './recharge-channel';
import RechargeButton from '@/components/business/recharge-button';
import globalStore from '@/services/global.state';
import {useTranslation} from 'react-i18next';
import {RouteProp, useFocusEffect, useRoute} from '@react-navigation/native';
import {getBalance, getRechargeCustomers} from '@/services/global.service';
import {useScreenSize} from '../hooks/size.hooks';
import RechargeTip from './recharge-tip';
import {getGiveSentStrs} from './recharge.utils';
import {homePage} from '@/config';
import {useLatest} from '@/common-pages/hooks/useLatest';
import {trackEvent} from '@/utils/track-event';
import {getVipWeekCardList, VipWeekCardConfigVO} from '../vip/vip.service';
import RechargeTab from './recharge-tab/recharge-tab';
import RechargeRule from './recharge-rule';
import {useRechargeStore} from './recharge.store';
import {getBalanceConfig} from './recharge-tab/recharge-tab.service';

const notToLanguageDomain = ['pay.wepaytm.xyz', 'pay.ptm-we.com'];
const notToLanguagePayName = ['we pay'];

const Recharge = () => {
  const {i18n} = useTranslation();
  // const [balanceList, setBalanceList] = React.useState<BalanceListItem[]>([]);
  const [paymethodList, setPaymenthodList] = React.useState<PayMethod[]>([]);
  const [weekCardList, setWeekCardList] = React.useState<VipWeekCardConfigVO[]>(
    [],
  );
  const [loading, setLoading] = React.useState(true);
  const [balance, setBalance] = React.useState('');
  const {calcActualSize} = useScreenSize();
  const [payMethodId, setPayMethodId] = React.useState<number>();
  const [activeWeekCardID, setActiveWeekCardID] = React.useState<number>();
  const route =
    useRoute<
      RouteProp<{params: {from: string; cardId: number; id?: string}}>
    >();
  const payMethodItem = useMemo(() => {
    return paymethodList.find(p => p.id === payMethodId);
  }, [paymethodList, payMethodId]);
  const fromWeekCard = useMemo(() => {
    return route.params?.from === 'weekCard';
  }, [route.params?.from]);
  const initWeekCardId = useMemo(() => {
    return route.params?.cardId;
  }, [route.params?.cardId]);

  // 获取URL中的id参数
  const tabId = useMemo(() => {
    return route.params?.id;
  }, [route.params?.id]);

  // 获取recharge store
  const {
    tabs,
    setActiveTabId,
    activeTabId,
    setBalanceList,
    balanceList,
    setBalanceConfig,
  } = useRechargeStore();

  // 处理tabId参数，初始选中对应的tab（但不阻止后续手动切换）
  const [hasInitialized, setHasInitialized] = useState(false);

  useEffect(() => {
    if (tabs.length > 0 && !hasInitialized) {
      if (fromWeekCard) {
        // 如果是从周卡页面进入，选中周卡tab（id为-2）
        console.log('Setting activeTabId to -2 for weekCard route');
        setActiveTabId(-2);
      } else if (tabId) {
        // 如果有tabId参数，选中对应的tab
        const targetTab = tabs.find(tab => tab.id === parseInt(tabId));
        if (targetTab) {
          console.log(
            `Setting initial activeTabId from route: ${targetTab.id}`,
          );
          setActiveTabId(targetTab.id);
        } else {
          // 如果没有匹配到，选中id为1的tab
          const defaultTab = tabs.find(tab => tab.id === 1);
          if (defaultTab) {
            console.log(`Setting default activeTabId: ${defaultTab.id}`);
            setActiveTabId(defaultTab.id);
          }
        }
      } else {
        // 如果都没有，默认选中第一个tab
        const firstTab = tabs[0];
        if (firstTab) {
          console.log(`Setting first tab as default: ${firstTab.id}`);
          setActiveTabId(firstTab.id);
        }
      }
      setHasInitialized(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabs, fromWeekCard, tabId]);

  const canShowBalanceList = useMemo(() => {
    // return balanceList.filter(
    //   _balance =>
    //     _balance.balance >= (payMethodItem?.minAmount || 0) &&
    //     _balance.balance <=
    //       (payMethodItem?.maxAmount || Number.MAX_SAFE_INTEGER),
    // );
    return balanceList.sort((a, b) => {
      return a.balance - b.balance;
    });
  }, [
    balanceList,
    // payMethodItem
  ]);
  const balanceId = useMemo(() => {
    const item = canShowBalanceList.find(b => b.balance === +balance);
    return item ? item.id + '' : '';
  }, [canShowBalanceList, balance]);

  const [amount, setAmount] = useState<number>(0);
  const [incomeInfo, setIncomeInfo] = React.useState({
    upiId: '',
    orderNo: '',
  });

  const sortedBalanceIndexList = useMemo(() => {
    const sortedList = Array(canShowBalanceList?.length)
      .fill(0)
      .map((_, i) => i);
    sortedList.sort(
      (a, b) =>
        (canShowBalanceList?.[a].balance || 0) -
        (canShowBalanceList?.[b].balance || 0),
    );
    return sortedList;
  }, [canShowBalanceList]);

  const extraBounsBalanceIndex = useMemo(() => {
    if (canShowBalanceList == null || canShowBalanceList.length <= 0) {
      return -1;
    }
    if (sortedBalanceIndexList.length <= 0) {
      return -1;
    }
    if (+balance < canShowBalanceList[sortedBalanceIndexList[0]].balance) {
      return -1;
    }
    let currentSortBalanceIndex = -1;
    // console.log(balance, '>>>>extraBounsBalanceIndex', sortedBalanceIndexList);
    // balance 是否 在 canShowBalanceList 中找到balance
    const balanceIndex = canShowBalanceList.findIndex(
      item => item.balance === +balance,
    );
    if (balanceIndex !== -1) {
      return balanceIndex;
    }
    // for (let i = 0; i < sortedBalanceIndexList.length; i++) {
    //   if (+balance >= canShowBalanceList[sortedBalanceIndexList[i]].balance) {
    //     currentSortBalanceIndex = sortedBalanceIndexList[i];
    //   } else {
    //     break;
    //   }
    // }
    return currentSortBalanceIndex;
  }, [canShowBalanceList, sortedBalanceIndexList, balance]);

  const extraSent = useMemo(() => {
    if (!payMethodItem) {
      return 0;
    }

    return getGiveSentStrs(
      payMethodItem,
      canShowBalanceList[extraBounsBalanceIndex],
    );
  }, [canShowBalanceList, extraBounsBalanceIndex, payMethodItem]);

  const isWeekCard = useMemo(() => {
    return fromWeekCard || activeTabId === -2;
  }, [fromWeekCard, activeTabId]);

  React.useEffect(() => {
    setLoading(true);
    if (isWeekCard) {
      Promise.all([getVipWeekCardList(), getPayMethod()])
        .then(([wclist, paymenthod]) => {
          setWeekCardList(wclist);
          setActiveWeekCardID(initWeekCardId || wclist[0].cardId);
          setPaymenthodList(paymenthod);
          setPayMethodId(paymenthod[0].id);
        })
        .finally(() => {
          setLoading(false);
        });
      return;
    }
    Promise.all([getBalanceList(), getPayMethod(), getBalanceConfig()])
      .then(([blance, paymenthod, balanceConfig]) => {
        setBalanceList(blance);
        //banlecList存储到store
        // setBalanceList(blance);
        // setBalance((blance[0]?.balance || '') + '');
        const paymentList = paymenthod.map(item => {
          return {
            ...item,
            disabled: false,
          };
        });
        setPaymenthodList(paymentList);
        setPayMethodId(paymentList[0].id);
        // 将balanceConfig存储到store
        setBalanceConfig(balanceConfig);
      })
      .finally(() => {
        setLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isWeekCard, initWeekCardId]);

  useEffect(() => {
    setBalance((canShowBalanceList[0]?.balance || '') + '');
  }, [canShowBalanceList]);

  const handleRefresh = useCallback(() => {
    if (!globalStore.token) {
      goTo('Login', {backPage: homePage});
      return;
    }
    setLoading(true);
    getBalance('')
      .then(res => {
        setAmount(res.mainBalance);
      })
      .finally(() => {
        setLoading(false);
      });
    // globalStore.updateAmount.next({});
  }, []);

  useEffect(() => {
    const card = weekCardList.find(_card => _card.cardId === activeWeekCardID);
    if (card) {
      setBalance(card.price + '');
    }
  }, [activeWeekCardID, weekCardList]);

  useFocusEffect(handleRefresh);
  const paymethodItemRef = useLatest(payMethodItem);
  const paymethodListRef = useLatest(paymethodList);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const channelValidationResult = useCallback(
    debounce(
      (
        balance: number,
        payMethodItem: PayMethod | undefined,
        list: PayMethod[],
      ) => {
        if (!list.length) {
          return;
        }
        let update = false;
        const result = list.map(item => {
          const disabled = balance
            ? item.minAmount > balance ||
              balance > (item.maxAmount || Number.MAX_SAFE_INTEGER)
            : false;

          if (
            (payMethodItem?.id === item.id && disabled) ||
            !payMethodItem?.id
          ) {
            // 如果当前存在选中的支付方式，则更新
            update = true;
          }
          return {
            ...item,
            disabled,
          };
        });
        if (update) {
          const newPayMethodItem =
            result.filter(item => !item.disabled)[0] || {};
          setPayMethodId(newPayMethodItem?.id);
        }
        setPaymenthodList(result);
      },
    ),
    [],
  );
  const handleGotoRecords = () => {
    if (!globalStore.token) {
      goTo('Login', {backPage: homePage});
      return;
    }
    if (isWeekCard) {
      goTo('WeekCardBuyRecord');
    } else {
      goTo('RechargeRecords');
    }
  };

  // 支付成功回调
  const onSuccess = (success: Success) => {
    if (success.status === 'SUCCESS') {
      paySuccess({
        orderNo: incomeInfo.orderNo,
        tradeResult: '1',
        approvalUrt: success.approvalRefNo,
      })
        .then()
        .finally(() => {
          globalStore.updateAmount.next({});
        });
    } else {
      // crashlytics().recordError(
      //   new Error(
      //     JSON.stringify({
      //       type: '支付成功,但状态不是success',
      //       incomeInfo: incomeInfo,
      //       successCB: success,
      //     }),
      //   ),
      // );
    }
  };
  const onFailure = (error: Error) => {
    globalStore.globalWaringTotal(error.message);
  };

  const handleRecharge = async () => {
    const {minAmount, maxAmount, payTag} = payMethodItem || {};

    if (
      !balance ||
      +balance <= 0 ||
      (minAmount && +balance < minAmount) ||
      (maxAmount && +balance > maxAmount)
    ) {
      globalStore.globalWaringTotal(i18n.t('recharge-page.tip.money-error'));
      return;
    }
    if (!payMethodItem) {
      globalStore.globalWaringTotal(
        i18n.t('recharge-page.tip.paymethod-error'),
      );
      return;
    }
    setLoading(true);
    trackEvent('rechargeClick', {
      amount: balance,
    });
    function getCustomer(customers: any[], status?: string): string {
      if (status) {
        const list = customers.filter(c => c.imUserStatus === status);
        return list.length
          ? list[Math.floor(Math.random() * list.length)].imUserId
          : getCustomer(customers);
      }
      return customers[Math.floor(Math.random() * customers.length)].imUserId;
    }
    goIncome({
      balanceId: balanceId || 0,
      payTag: payMethodItem.payTag,
      payTypeId: payMethodId + '',
      rechargeBalance: balanceId ? 0 : balance,
      ...(isWeekCard ? {cardId: activeWeekCardID} : {}),
    })
      .then(res => {
        if (payTag === 'IM_RECHARGE') {
          getRechargeCustomers().then(customers => {
            const rechargeCustomers = customers.filter(
              c => c.imCustomer === '1',
            );
            if (rechargeCustomers.length <= 0) {
              globalStore.globalWaringTotal(
                i18n.t('recharge-page.tip.no-recharge-customer'),
              );
              return;
            }

            // goTo('Chat', {
            //   amount: balance,
            //   customerId:
            //     rechargeCustomers[
            //       Math.floor(Math.random() * rechargeCustomers.length)
            //     ].imUserId,
            // });

            goTo(homePage, {
              screen: 'Chat',
              params: {
                amount: balance,
                customerId: getCustomer(rechargeCustomers, '1'),
              },
            });
          });

          return;
        }
        if (typeof res === 'string') {
          if (res.indexOf('#amount#') > -1) {
            res = res.replace('#amount#', balance);
          }

          if (
            !(
              notToLanguageDomain.some(v => (res as string).includes(v)) ||
              notToLanguagePayName.some(v =>
                payMethodItem?.payName?.toLowerCase().includes(v),
              )
            )
          ) {
            if (res.indexOf('?') > -1) {
              res += '&lang=' + globalStore.lang;
            } else {
              res += '?lang=' + globalStore.lang;
            }
          }

          if (globalStore.isWeb) {
            if (inGameBox) {
              openURL(res);
            } else {
              location.href = res;
            }
          } else {
            goTo('WebView', {
              originUrl: res,
              header: true,
              headerTitle: i18n.t('label.recharge'),
              serverRight: true,
              hideAmount: true,
            });
          }
        } else {
          setIncomeInfo(res);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };
  // 吊起APP支付
  const onPay = () => {
    const config = {
      payeeVpa: incomeInfo.upiId,
      payeeName: incomeInfo.upiId,
      merchantCode: incomeInfo.upiId,
      transactionId: incomeInfo.orderNo,
      transactionRefId: incomeInfo.orderNo,
      description: incomeInfo.orderNo,
      amount: balance + '',
    };
    upiPayment.initiate('net.one97.paytm', '', config, onSuccess, onFailure);
  };

  React.useEffect(() => {
    if (incomeInfo.orderNo && incomeInfo.upiId) {
      onPay();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [incomeInfo]);
  useEffect(() => {
    channelValidationResult(
      +balance,
      paymethodItemRef.current,
      paymethodListRef.current,
    );
  }, [balance, channelValidationResult, paymethodItemRef, paymethodListRef]);

  return (
    <View style={[theme.fill.fill, theme.flex.col, theme.background.lightGrey]}>
      <DetailNavTitle
        onBack={goBack}
        serverRight
        hideAmount
        title={
          isWeekCard
            ? i18n.t('vip.label.weekCardRecharge')
            : i18n.t('label.recharge')
        }
      />
      <Spin loading={loading} style={[theme.flex.flex1, theme.flex.col]}>
        <View
          style={[
            theme.flex.flex1,
            theme.flex.basis0,
            {
              paddingBottom: calcActualSize(theme.paddingSize.s),
            },
          ]}>
          <ScrollView
            contentContainerStyle={[
              {
                paddingTop: calcActualSize(theme.paddingSize.l),
                paddingHorizontal: calcActualSize(theme.paddingSize.l),
                gap: calcActualSize(theme.paddingSize.l),
              },
            ]}>
            <RechargeBalance
              balance={amount}
              payMethod={payMethodItem?.payName}
              onRefresh={handleRefresh}
              onGotoRecords={handleGotoRecords}
              fromWeekCard={isWeekCard}
            />
            {/* tab - 只有非周卡模式才显示 */}
            <RechargeTab onTabChange={() => {}} loading={false} />
            <WeekCardRechargeTabContext.Provider
              value={{
                fromWeekCard: isWeekCard,
                activeCardId: activeWeekCardID || 0,
                updateActiveCardId: setActiveWeekCardID,
                weekCardList,
              }}>
              <RechargeSelect
                min={payMethodItem?.minAmount || 0}
                max={payMethodItem?.maxAmount || 0}
                balance={balance}
                balanceList={canShowBalanceList}
                payMethod={payMethodItem}
                extraBounsBalanceIndex={extraBounsBalanceIndex}
                onChangeBalance={balance => {
                  setBalance(balance);
                }}
              />
            </WeekCardRechargeTabContext.Provider>
            <RechargeChannel
              payMethodList={paymethodList}
              onPayMethodChange={setPayMethodId}
              payMethodId={payMethodId}
            />
            <RechargeRule fromWeekCard={isWeekCard} />
          </ScrollView>
        </View>
        <RechargeButton
          type="linear-primary"
          disabled={
            balance === '' ||
            +balance <= 0 ||
            typeof payMethodId === 'undefined'
          }
          onRecharge={handleRecharge}
          receiveTip={
            extraSent ? (
              <RechargeTip
                style={{left: calcActualSize(149), right: 'auto'}}
                animateType="95">
                {i18n.t('recharge.tip.extra', {
                  bonus: extraSent,
                })}
              </RechargeTip>
            ) : undefined
          }
          balance={balance}
          payMethod={payMethodItem}
          balanceItem={canShowBalanceList[extraBounsBalanceIndex]}
          isWeekCard={isWeekCard}
        />
      </Spin>
    </View>
  );
};

export default Recharge;
